const env = require('/opt/build/repo/twing/environment.js');
let templatesModule = (() => {
let module = {
    exports: undefined
};

module.exports = (TwingTemplate) => {
    return new Map([
        [0, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = false;

                this.blocks = new Map([
                ]);
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                context.proxy[`_deck_class`] = ``;
                this.echo(`
`);
                if (!!(!!(!!((context.has(`columns`) ? context.get(`columns`) : null) && ((context.has(`columns`) ? context.get(`columns`) : null) > 1)) && (context.has(`columnsBreakpoint`) ? context.get(`columnsBreakpoint`) : null)) && !this.compare((context.has(`columnsBreakpoint`) ? context.get(`columnsBreakpoint`) : null), `none`))) {
                    this.echo(`  `);
                    context.proxy[`_deck_class`] = (((`o-deck--` + (context.has(`columns`) ? context.get(`columns`) : null)) + `-column`) + (context.has(`columnsBreakpoint`) ? context.get(`columnsBreakpoint`) : null));
                }
                this.echo(`
`);
                if ((context.has(`class`) ? context.get(`class`) : null)) {
                    this.echo(`  `);
                    context.proxy[`_deck_class`] = (((context.has(`_deck_class`) ? context.get(`_deck_class`) : null) + ` `) + (context.has(`class`) ? context.get(`class`) : null));
                }
                this.echo(`
`);
                if ((context.has(`alignment`) ? context.get(`alignment`) : null)) {
                    this.echo(`  `);
                    context.proxy[`_deck_class`] = (((context.has(`_deck_class`) ? context.get(`_deck_class`) : null) + ` `) + (context.has(`alignment`) ? context.get(`alignment`) : null));
                }
                this.echo(`
`);
                if (this.compare((context.has(`alignment`) ? context.get(`alignment`) : null), `alignwide`)) {
                    this.echo(`<div class="o-container--prose">
  <div class="o-container__content">
`);
                }
                this.echo(`    `);
                this.echo(this.include(context, this.source, this.loadTemplate(`c0235722316c8d75958c4659b2f566be76f547b7d2c26bae8acbbeacd591dd6e`, `c0235722316c8d75958c4659b2f566be76f547b7d2c26bae8acbbeacd591dd6e`, 23, 70), new Map([[`class`, (context.has(`_deck_class`) ? context.get(`_deck_class`) : null)]]), true, false, 23));
                if (this.compare((context.has(`alignment`) ? context.get(`alignment`) : null), `alignwide`)) {
                    this.echo(`  </div>
</div>
`);
                }
            }

            getTemplateName() {
                return `c0235722316c8d75958c4659b2f566be76f547b7d2c26bae8acbbeacd591dd6e`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `c0235722316c8d75958c4659b2f566be76f547b7d2c26bae8acbbeacd591dd6e`, ``);
            }
        }],
        [70, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = this.loadTemplate(`@cloudfour/objects/deck/deck.twig`, `c0235722316c8d75958c4659b2f566be76f547b7d2c26bae8acbbeacd591dd6e`, 23);

                this.blocks = new Map([
                    ['content', [this, 'block_content']]
                ]);
            }

            doGetParent(context) {
                return `@cloudfour/objects/deck/deck.twig`;
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.parent.display(context, this.merge(this.blocks, blocks));
            }

            block_content(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`        `);
                context.set('_parent', context.clone());

                (() => {
                    let c = this.ensureTraversable((context.has(`items`) ? context.get(`items`) : null));

                    if (c === context) {
                        context.set('_seq', context.clone());
                    }
                    else {
                        context.set('_seq', c);
                    }
                })();

                context.set('loop', new Map([
                  ['parent', context.get('_parent')],
                  ['index0', 0],
                  ['index', 1],
                  ['first', true]
                ]));
                if ((typeof context.get('_seq') === 'object') && this.isCountable(context.get('_seq'))) {
                    let length = this.count(context.get('_seq'));
                    let loop = context.get('loop');
                    loop.set('revindex0', length - 1);
                    loop.set('revindex', length);
                    loop.set('length', length);
                    loop.set('last', (length === 1));
                }
                this.iterate(context.get('_seq'), (__key__, __value__) => {
                    context.proxy[`_key`] = __key__;
                    context.proxy[`item`] = __value__;
                    this.echo(`          `);
                    if (!!(!!(this.compare(this.traceableMethod(this.getAttribute, 28, this.source)(this.env, context.get(`loop`), `index`, new Map([]), `any`, false, false, false), (context.has(`horizontalItem`) ? context.get(`horizontalItem`) : null)) && (context.has(`horizontalBreakpoint`) ? context.get(`horizontalBreakpoint`) : null)) && !this.compare((context.has(`horizontalBreakpoint`) ? context.get(`horizontalBreakpoint`) : null), `none`))) {
                        this.echo(`            `);
                        context.proxy[`_card_class`] = (`c-card--horizontal` + (context.has(`horizontalBreakpoint`) ? context.get(`horizontalBreakpoint`) : null));
                        this.echo(`          `);
                    }
                    else {
                        this.echo(`            `);
                        context.proxy[`_card_class`] = ``;
                        this.echo(`          `);
                    }
                    this.echo(`          `);
                    this.echo(this.include(context, this.source, this.loadTemplate(`c0235722316c8d75958c4659b2f566be76f547b7d2c26bae8acbbeacd591dd6e`, `c0235722316c8d75958c4659b2f566be76f547b7d2c26bae8acbbeacd591dd6e`, 33, 69), new Map([[`class`, (context.has(`_card_class`) ? context.get(`_card_class`) : null)], [`href`, this.traceableMethod(this.getAttribute, 35, this.source)(this.env, context.get(`item`), `link`, new Map([]), `any`, false, false, false)]]), true, false, 33));
                    this.echo(`        `);
                    (() => {
                        let loop = context.get('loop');
                        loop.set('index0', loop.get('index0') + 1);
                        loop.set('index', loop.get('index') + 1);
                        loop.set('first', false);
                        if (loop.has('length')) {
                            loop.set('revindex0', loop.get('revindex0') - 1);
                            loop.set('revindex', loop.get('revindex') - 1);
                            loop.set('last', loop.get('revindex0') === 0);
                        }
                    })();
                });
                (() => {
                    let parent = context.get('_parent');
                    context.delete('_seq');
                    context.delete('_iterated');
                    context.delete('_key');
                    context.delete('item');
                    context.delete('_parent');
                    context.delete('loop');
                    for (let [k, v] of parent) {
                        if (!context.has(k)) {
                            context.set(k, v);
                        }
                    }
                })();
                this.echo(`      `);
            }

            getTemplateName() {
                return `c0235722316c8d75958c4659b2f566be76f547b7d2c26bae8acbbeacd591dd6e`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `c0235722316c8d75958c4659b2f566be76f547b7d2c26bae8acbbeacd591dd6e`, ``);
            }
        }],
        [69, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = this.loadTemplate(`@cloudfour/components/card/card.twig`, `c0235722316c8d75958c4659b2f566be76f547b7d2c26bae8acbbeacd591dd6e`, 33);

                this.blocks = new Map([
                    ['heading', [this, 'block_heading']],
                    ['cover', [this, 'block_cover']],
                    ['content', [this, 'block_content']],
                    ['footer', [this, 'block_footer']]
                ]);
            }

            doGetParent(context) {
                return `@cloudfour/components/card/card.twig`;
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.parent.display(context, this.merge(this.blocks, blocks));
            }

            block_heading(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`              `);
                this.echo(this.env.getFilter('escape').traceableCallable(38, this.source)(...[this.env, this.traceableMethod(this.getAttribute, 38, this.source)(this.env, (context.has(`item`) ? context.get(`item`) : null), `title`, new Map([]), `any`, false, false, false), `html`, null, true]));
                this.echo(`
            `);
            }

            block_cover(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`              <img src="`);
                this.echo(this.env.getFilter('escape').traceableCallable(41, this.source)(...[this.env, this.traceableMethod(this.getAttribute, 41, this.source)(this.env, (context.has(`item`) ? context.get(`item`) : null), `thumbnail`, new Map([]), `any`, false, false, false), `html`, null, true]));
                this.echo(`" alt="">
            `);
            }

            block_content(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`              <p>
                `);
                if ((this.env.getFilter('length').traceableCallable(45, this.source)(...[this.env, this.traceableMethod(this.getAttribute, 45, this.source)(this.env, (context.has(`item`) ? context.get(`item`) : null), `description`, new Map([]), `any`, false, false, false)]) > 140)) {
                    this.echo(`                  `);
                    this.echo(this.env.getFilter('escape').traceableCallable(46, this.source)(...[this.env, this.env.getFilter('trim').traceableCallable(46, this.source)(...[this.env.getFilter('slice').traceableCallable(46, this.source)(...[this.env, this.traceableMethod(this.getAttribute, 46, this.source)(this.env, (context.has(`item`) ? context.get(`item`) : null), `description`, new Map([]), `any`, false, false, false), 0, 140])]), `html`, null, true]));
                    this.echo(`…
                `);
                }
                else {
                    this.echo(`                  `);
                    this.echo(this.env.getFilter('escape').traceableCallable(48, this.source)(...[this.env, this.traceableMethod(this.getAttribute, 48, this.source)(this.env, (context.has(`item`) ? context.get(`item`) : null), `description`, new Map([]), `any`, false, false, false), `html`, null, true]));
                    this.echo(`
                `);
                }
                this.echo(`              </p>
            `);
            }

            block_footer(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`              <p>`);
                this.echo(this.env.getFilter('escape').traceableCallable(53, this.source)(...[this.env, this.traceableMethod(this.getAttribute, 53, this.source)(this.env, (context.has(`item`) ? context.get(`item`) : null), `author`, new Map([]), `any`, false, false, false), `html`, null, true]));
                this.echo(`</p>
              <p>`);
                this.echo(this.env.getFilter('escape').traceableCallable(54, this.source)(...[this.env, this.env.getFilter('date').traceableCallable(54, this.source)(...[this.env, this.traceableMethod(this.getAttribute, 54, this.source)(this.env, (context.has(`item`) ? context.get(`item`) : null), `pubDate`, new Map([]), `any`, false, false, false), `M j, Y`]), `html`, null, true]));
                this.echo(`</p>
            `);
            }

            getTemplateName() {
                return `c0235722316c8d75958c4659b2f566be76f547b7d2c26bae8acbbeacd591dd6e`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `c0235722316c8d75958c4659b2f566be76f547b7d2c26bae8acbbeacd591dd6e`, ``);
            }
        }],
    ]);
};

    return module.exports;
})();

env.registerTemplatesModule(templatesModule, 'c0235722316c8d75958c4659b2f566be76f547b7d2c26bae8acbbeacd591dd6e');

let template = env.loadTemplate('c0235722316c8d75958c4659b2f566be76f547b7d2c26bae8acbbeacd591dd6e');

module.exports = (context = {}) => {
    const rendered = template.render(context);
     const inputs = window.__twig_inputs__ || (window.__twig_inputs__ = new Map());
     inputs.set(
       rendered,
       { path: "@cloudfour/objects/deck/demo/articles.twig", args: context }
     );
     return rendered;;
};